import React from "react";
import ShipPage from "./Shipmapp"; // adjust path

const VessalControl = () => {
  return <ShipPage />;
}

export default VessalControl;